// extracted by mini-css-extract-plugin
export default {"host":"MainMenuItem_host__osOOR","host_active":"MainMenuItem_host_active__AQped","inner":"MainMenuItem_inner__fuhUw"};